import * as React from "react";
const SvgShare = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.523 14.097a5.047 5.047 0 0 0-5.1 1.15.442.442 0 0 1-.476.097l-4.703-1.873a.21.21 0 0 1-.11-.155l-.056-.651c0-.076.04-.145.103-.185l5.389-3.253a.451.451 0 0 1 .49.022 5.048 5.048 0 0 0 7.684-2.63 5.096 5.096 0 0 0-.748-4.535A5.085 5.085 0 0 0 18.903 0a5.174 5.174 0 0 0-3.719 1.741 5.185 5.185 0 0 0-1.283 3.904.449.449 0 0 1-.212.408L8.41 9.227a.451.451 0 0 1-.49-.022 5.049 5.049 0 0 0-7.683 2.631 5.095 5.095 0 0 0 .749 4.534 5.084 5.084 0 0 0 4.092 2.084 5.028 5.028 0 0 0 3.478-1.405.451.451 0 0 1 .48-.098l4.54 1.846a.44.44 0 0 1 .266.395 5.08 5.08 0 0 0 3.19 4.431 5.07 5.07 0 0 0 5.36-1.026 5.084 5.084 0 0 0 1.332-5.297 4.945 4.945 0 0 0-3.2-3.203z"
      fill={props.color}
      fillRule="evenodd"
    />
  </svg>
);
export default SvgShare;
